import React from "react";
import { Col, Row } from "react-bootstrap";
import { Input } from "../../../../../library/input";
import { Label } from "../../../../../library/label";
import "./style.scss";

const Index = ({ verificationDetails, setVerificationDetails }) => {
  return (
    <div className="domain-configuration-container">
      <Row className="info-row">
        <Col className="info-col">
          <Label version={1} weight="bold">
            Domene
          </Label>
          <Input
            placeholder="Domene"
            value={verificationDetails.domain}
            onChange={(e) =>
              setVerificationDetails({
                ...verificationDetails,
                domain: e.target.value,
              })
            }
          />
          <small>
            F.eks <u>leadfind.no</u>
          </small>
        </Col>
      </Row>
    </div>
  );
};

export default Index;
